<div class="range-form">
  <div class="date-selectors">
    <div class="ui-g">
      <div class="ui-g-3">
        <span style="margin-right: 5px">Starting month/year:</span>
      </div>
      <div class="ui-g-3">
        <span style="margin-right: 5px">
          <p-calendar
            [(ngModel)]="kpiStartDate"
            [showTime]="false"
            name="kpiStartDate"
            view="month"
            dateFormat="MM yy"
            (ngModelChange)="onDateRangeChanged($event)"
            [minDate]="minKPIDate"
          ></p-calendar>
        </span>
      </div>
      <div class="ui-g-6" *ngIf="dateRange">
        Viewing data from
        <span class="date-label">{{ dateRange.from | datex : "ddd DD MMM 'YY" }}</span> to
        <span class="date-label">{{ dateRange.to | datex : "ddd DD MMM 'YY" }}</span>
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-6">
        <p-dropdown
          name="dateRangeOptions1"
          [options]="dateRangeOptions"
          [(ngModel)]="selectedDateRange"
          styleClass="filterItem"
          [style]="{ width: '100%' }"
          (onChange)="onDateRangeChanged($event)"
        ></p-dropdown>
      </div>
      <div class="ui-g-6" *ngIf="selectedDateRange == DateRangeOptionEnum.Daily">
        <p-dropdown
          name="dateRangeOptions2"
          [options]="dailyDateRangeOptions"
          [(ngModel)]="selectedDailyDateRangeOption"
          styleClass="filterItem"
          [style]="{ width: '100%' }"
          (onChange)="onDateRangeChanged($event)"
        ></p-dropdown>
      </div>
      <div class="ui-g-6" *ngIf="selectedDateRange == DateRangeOptionEnum.Weekly">
        <p-dropdown
          name="dateRangeOptions3"
          [options]="weeklyDateRangeOptions"
          [(ngModel)]="selectedWeeklyDateRangeOption"
          styleClass="filterItem"
          [style]="{ width: '100%' }"
          (onChange)="onDateRangeChanged($event)"
        ></p-dropdown>
      </div>
      <div class="ui-g-6" *ngIf="selectedDateRange == DateRangeOptionEnum.Monthly">
        <p-dropdown
          name="dateRangeOptions4"
          [options]="monthlyDateRangeOptions"
          [(ngModel)]="selectedMonthlyDateRangeOption"
          styleClass="filterItem"
          [style]="{ width: '100%' }"
          (onChange)="onDateRangeChanged($event)"
        ></p-dropdown>
      </div>
    </div>
  </div>

  <div class="kpi-filters">
    <div class="ui-g">
      <div class="ui-g-6">
        <p-dropdown
          name="department"
          [options]="deptOptions"
          [(ngModel)]="selectedDept"
          styleClass="filterItem"
          [style]="{ width: '100%' }"
          (onChange)="onDepartmentChanged($event)"
        ></p-dropdown>
      </div>
      <div class="ui-g-6">
        <p-dropdown
          name="orderTags"
          [options]="orderTagOptions"
          [(ngModel)]="selectedOrderTag"
          styleClass="filterItem"
          [style]="{ width: '100%' }"
          (onChange)="onOrderTagChanged($event)"
        ></p-dropdown>
      </div>
    </div>
  </div>
</div>

<p-tabView #tabView (onChange)="chartTabChanged($event)">
  <!--    <p-tabPanel header="Summary" #tabSummary tab class="chart-tab-panel">-->
  <!--        <dashboard-customer-kpi-summary [tabIndex]="0"></dashboard-customer-kpi-summary>-->
  <!--    </p-tabPanel>-->
  <p-tabPanel header="Volume" #tabVolume tab class="chart-tab-panel">
    <dashboard-customer-kpi-volume [tabIndex]="1"></dashboard-customer-kpi-volume>
  </p-tabPanel>
  <!--    <p-tabPanel header="Service Level" #tabServiceLevel class="chart-tab-panel">-->
  <!--        <dashboard-customer-kpi-service-levels [tabIndex]="2"></dashboard-customer-kpi-service-levels>-->
  <!--    </p-tabPanel>-->
  <!--    <p-tabPanel header="Time Windows" #tabTimeWindows class="chart-tab-panel">-->
  <!--        <dashboard-customer-kpi-time-windows [tabIndex]="3"></dashboard-customer-kpi-time-windows>-->
  <!--    </p-tabPanel>-->
  <!--    <p-tabPanel header="Urgency" #tabUrgency class="chart-tab-panel">-->
  <!--        <dashboard-customer-kpi-urgency [tabIndex]="4"></dashboard-customer-kpi-urgency>-->
  <!--    </p-tabPanel>-->

  <div style="text-align: right; margin: 5px">
    <button
      type="button"
      pButton
      (click)="exportCSV()"
      [disabled]="csvDownloading"
      pTooltip="Download all metrics to CSV file"
      tooltipPosition="left"
    >
      <span class="chart-loading button-text" *ngIf="csvDownloading"
        ><i class="fa fa-spinner fa-spin"></i>&nbsp; Downloading CSV...</span
      >
      <span *ngIf="!csvDownloading" class="button-text">
        <i class="fa fa-cloud-download"></i> Export To CSV</span
      >
    </button>
  </div>
</p-tabView>
